import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useT } from '@progress-fe/core';
import { Button, Grid } from '@chakra-ui/react';
import { Input, VirtualTable } from '../../../../index';
const HypotheticalComponentsFC = ({ tableSx }) => {
    const [query, setQuery] = useState('');
    const { t } = useT();
    return (_jsxs(Grid, { templateRows: "auto 1fr", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: "1fr 140px", gap: "8px", children: [_jsx(Input, { size: "xs", value: query, variant: "outline", placeholder: t('actions.search'), onChange: setQuery }), _jsx(Button, { size: "xs", variant: "ghost", children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C" })] }), _jsx(VirtualTable, { rows: [], columns: [], isCheckboxShown: true, noItemsTitle: t('components.no'), tableSx: tableSx })] }));
};
export const HypotheticalComponents = observer(HypotheticalComponentsFC);
//# sourceMappingURL=HypotheticalComponents.js.map